import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import LoadingPopup from "./loading";
import { secretKey } from "./data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import LeadDetail from "./leadDetail";
import SendClientsConf from "./sendClientsConf";
import SendLeadsDetails from "./sendLeadsDetails";
import ImportLeadSend from "./importLeadsSend";
import SendClientsResults from "./sendClientsResults";
import { downloadExcel } from "react-export-table-to-excel";

const MySwal = withReactContent(Swal2);

const ClickReport = (props) => {
  const [loading, setLoading] = useState(false);
  const [clicks, setClicks] = useState([]);
  const [clicksDetail, setClicksDetail] = useState([]);
  const [users, setUsers] = useState([]);
  const [days, setDays] = useState([]);
  const [hours, setHours] = useState([]);
  const [user, setUser] = useState("");

  const fetchClicks = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getClicksReport", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClicks(data);
        var arr = [];
        data.map((el) => {
          if (
            arr.filter(
              (e) =>
                e
                  .replaceAll(" SKD", "")
                  .replaceAll(" CHF", "")
                  .replaceAll(" WIBOR", "") ===
                el.user
                  .replaceAll(" SKD", "")
                  .replaceAll(" CHF", "")
                  .replaceAll(" WIBOR", "")
            ).length === 0
          ) {
            arr.push(
              el.user
                .replaceAll(" SKD", "")
                .replaceAll(" CHF", "")
                .replaceAll(" WIBOR", "")
            );
          }
        });
        setUsers(arr);
        setUser(arr[0]);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchClicksDetails = async () => {
    var body = { user: user };

    await fetch("https://apisellcrm.ftpeople.pl/getClicksReportDetail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClicksDetail(data);
        var arr = [];
        data.map((r) => {
          var date =
            new Date(r.time).getFullYear() +
            "-" +
            (new Date(r.time).getMonth() + 1 < 10
              ? "0" + (new Date(r.time).getMonth() + 1)
              : new Date(r.time).getMonth() + 1) +
            "-" +
            (new Date(r.time).getDate() < 10
              ? "0" + new Date(r.time).getDate()
              : new Date(r.time).getDate());
          if (arr.filter((p) => p === date).length === 0) {
            arr.push(date);
          }
        });
        setDays(arr);
        var arr2 = [];
        data.map((a) => {
          var hour = new Date(a.time).getHours();
          var date =
            new Date(a.time).getFullYear() +
            "-" +
            (new Date(a.time).getMonth() + 1 < 10
              ? "0" + (new Date(a.time).getMonth() + 1)
              : new Date(a.time).getMonth() + 1) +
            "-" +
            (new Date(a.time).getDate() < 10
              ? "0" + new Date(a.time).getDate()
              : new Date(a.time).getDate());

          if (
            arr2.filter((t) => t.day == date && t.hour === hour).length === 0
          ) {
            arr2.push({
              day: date,
              hour: hour,
              on: data.filter(
                (el) =>
                  el.type === "on" &&
                  new Date(el.time).getFullYear() +
                    "-" +
                    (new Date(el.time).getMonth() + 1 < 10
                      ? "0" + (new Date(el.time).getMonth() + 1)
                      : new Date(el.time).getMonth() + 1) +
                    "-" +
                    (new Date(el.time).getDate() < 10
                      ? "0" + new Date(el.time).getDate()
                      : new Date(el.time).getDate()) ===
                    date &&
                  new Date(el.time).getHours() === hour
              ).length,
              onTime:
                data.filter(
                  (el) =>
                    el.type === "on" &&
                    new Date(el.time).getFullYear() +
                      "-" +
                      (new Date(el.time).getMonth() + 1 < 10
                        ? "0" + (new Date(el.time).getMonth() + 1)
                        : new Date(el.time).getMonth() + 1) +
                      "-" +
                      (new Date(el.time).getDate() < 10
                        ? "0" + new Date(el.time).getDate()
                        : new Date(el.time).getDate()) ===
                      date &&
                    new Date(el.time).getHours() === hour
                ).length * 5,
              off: data.filter(
                (el) =>
                  el.type === "off" &&
                  new Date(el.time).getFullYear() +
                    "-" +
                    (new Date(el.time).getMonth() + 1 < 10
                      ? "0" + (new Date(el.time).getMonth() + 1)
                      : new Date(el.time).getMonth() + 1) +
                    "-" +
                    (new Date(el.time).getDate() < 10
                      ? "0" + new Date(el.time).getDate()
                      : new Date(el.time).getDate()) ===
                    date &&
                  new Date(el.time).getHours() === hour
              ).length,
              offTime:
                data.filter(
                  (el) =>
                    el.type === "off" &&
                    new Date(el.time).getFullYear() +
                      "-" +
                      (new Date(el.time).getMonth() + 1 < 10
                        ? "0" + (new Date(el.time).getMonth() + 1)
                        : new Date(el.time).getMonth() + 1) +
                      "-" +
                      (new Date(el.time).getDate() < 10
                        ? "0" + new Date(el.time).getDate()
                        : new Date(el.time).getDate()) ===
                      date &&
                    new Date(el.time).getHours() === hour
                ).length * 1,
              offDay: data.filter(
                (el) =>
                  el.type === "off" &&
                  new Date(el.time).getFullYear() +
                    "-" +
                    (new Date(el.time).getMonth() + 1 < 10
                      ? "0" + (new Date(el.time).getMonth() + 1)
                      : new Date(el.time).getMonth() + 1) +
                    "-" +
                    (new Date(el.time).getDate() < 10
                      ? "0" + new Date(el.time).getDate()
                      : new Date(el.time).getDate()) ===
                    date
              ).length,
              offTimeDay:
                data.filter(
                  (el) =>
                    el.type === "off" &&
                    new Date(el.time).getFullYear() +
                      "-" +
                      (new Date(el.time).getMonth() + 1 < 10
                        ? "0" + (new Date(el.time).getMonth() + 1)
                        : new Date(el.time).getMonth() + 1) +
                      "-" +
                      (new Date(el.time).getDate() < 10
                        ? "0" + new Date(el.time).getDate()
                        : new Date(el.time).getDate()) ===
                      date
                ).length * 1,
              onDay: data.filter(
                (el) =>
                  el.type === "on" &&
                  new Date(el.time).getFullYear() +
                    "-" +
                    (new Date(el.time).getMonth() + 1 < 10
                      ? "0" + (new Date(el.time).getMonth() + 1)
                      : new Date(el.time).getMonth() + 1) +
                    "-" +
                    (new Date(el.time).getDate() < 10
                      ? "0" + new Date(el.time).getDate()
                      : new Date(el.time).getDate()) ===
                    date
              ).length,
              onTimeDay:
                data.filter(
                  (el) =>
                    el.type === "on" &&
                    new Date(el.time).getFullYear() +
                      "-" +
                      (new Date(el.time).getMonth() + 1 < 10
                        ? "0" + (new Date(el.time).getMonth() + 1)
                        : new Date(el.time).getMonth() + 1) +
                      "-" +
                      (new Date(el.time).getDate() < 10
                        ? "0" + new Date(el.time).getDate()
                        : new Date(el.time).getDate()) ===
                      date
                ).length * 5,
            });
          }
        });
        setHours(arr2);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    fetchClicks();
  };

  const getDataDetails = () => {
    setLoading(true);
    fetchClicksDetails();
  };

  useEffect(() => {
    getData();
  }, []);

  const getWorkTime = (timeNum) => {
    var min = timeNum * 60;

    var hours = Math.floor(min / 60);
    console.log(hours);

    var min = (min - hours * 60).toFixed(0);

    return hours + ":" + (min < 10 ? "0" + min : min);
  };

  return (
    <div>
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div
            style={{
              backgroundColor: "white",
              top: "0",
              paddingTop: "2vh",
              paddingBottom: "1vh",
              paddingLeft: "0vw",
              paddingRight: "0vw",
              borderTop: "2px solid gray",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                gap: "1vw",
                alignItems: "center",
              }}
            >
              <select
                style={{ border: "1px solid gray" }}
                value={user}
                onChange={(e) => {
                  setUser(e.target.value);
                }}
              >
                {users.map((user) => (
                  <option key={user} value={user}>
                    {user}
                  </option>
                ))}
              </select>
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  backgroundColor: "green",
                  borderColor: "green",
                  width: "180px",
                }}
                onClick={() => {
                  getDataDetails();
                }}
              >
                POKAŻ
              </button>
            </div>
          </div>
          <div
            style={{
              paddingTop: "2vh",
              paddingBottom: "0vh",
            }}
          >
            {days
              ? days.map((day) => (
                  <>
                    <p
                      style={{
                        textAlign: "left",
                        margin: "0",
                        fontSize: "1vw",
                        marginBottom: "10px",
                        marginTop: "10px",
                      }}
                    >
                      {day} - ilość godzin:{" "}
                      {hours.filter((e) => e.day === day).length} - ilość
                      odebranych: {hours.filter((e) => e.day === day)[0].onDay}{" "}
                      - ilość nieodebranych:{" "}
                      {hours.filter((e) => e.day === day)[0].offDay} -
                      przepracowano w dniu:{" "}
                      {getWorkTime(
                        (
                          (hours.filter((e) => e.day === day)[0].offTimeDay +
                            hours.filter((e) => e.day === day)[0].onTimeDay) /
                          60
                        ).toFixed(1)
                      )}
                    </p>
                    {hours
                      .filter((e) => e.day === day)
                      .map((hour) => (
                        <div style={{ display: "flex" }}>
                          <p
                            style={{
                              textAlign: "left",
                              paddingLeft: "20px",
                              margin: "0",
                              fontSize: "1vw",
                              width: "5vw",
                            }}
                          >
                            {hour.hour} - {hour.hour + 1}:
                          </p>
                          <span>
                            ilość odebranych -{" "}
                            {
                              hours.filter(
                                (e) => e.day === day && e.hour === hour.hour
                              )[0].on
                            }{" "}
                            (
                            {getWorkTime(
                              (hours.filter(
                                (e) => e.day === day && e.hour === hour.hour
                              )[0].on *
                                5) /
                                60
                            )}
                            )
                          </span>
                          <span style={{ paddingLeft: "15px" }}>
                            ilość nieodebranych -{" "}
                            {
                              hours.filter(
                                (e) => e.day === day && e.hour === hour.hour
                              )[0].off
                            }{" "}
                            (
                            {getWorkTime(
                              (hours.filter(
                                (e) => e.day === day && e.hour === hour.hour
                              )[0].off *
                                1) /
                                60
                            )}
                            ){" "}
                          </span>
                        </div>
                      ))}
                  </>
                ))
              : ""}
          </div>
        </>
      )}
    </div>
  );
};

export default ClickReport;
